export interface Timezone {
  label: string;
  value: string;
}

export const TIMEZONES: Timezone[] = Intl.supportedValuesOf('timeZone').map((timezone) => ({
  label: timezone,
  value: timezone,
}));
